import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AppTitle } from "@/shared/Components";
import { useLazyGetNoteByIdQuery, useLazyGetPersonByIdQuery } from "@/services/api";
import { notesManagerActions } from "@/features/NotesManager/model";
import { useAppDispatch } from "@/services/store";
import { AppHighlighter } from "@/shared/Components/AppHighlighter";
import type { SearchResponseItem } from "@/services/api/entities/search";
import { SearchCardField } from "../../CardField";
import styles from "./styles.module.scss";

type NoteSearchCardProps = {
  item: SearchResponseItem;
  setOpen: (value: boolean) => void;
  textQuery: string;
};

export const NoteSearchCard = (props: NoteSearchCardProps) => {
  const [getNoteById, { data: noteResponse }] = useLazyGetNoteByIdQuery();
  const [getPersonById, { data: personResponse }] = useLazyGetPersonByIdQuery();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (props.item.noteId) {
      getNoteById({ noteId: props.item.noteId });
    }
  }, []);

  useEffect(() => {
    if (noteResponse?.personId) {
      getPersonById({ id: noteResponse.personId });
    }
  }, [noteResponse?.personId]);

  const handleNoteClick = () => {
    props.setOpen(false);

    if (noteResponse && personResponse) {
      dispatch(
        notesManagerActions.addSelectedNote({
          ...noteResponse,
          person: personResponse,
        }),
      );
      navigate("/notes");
    }
  };

  return (
    <div onClick={handleNoteClick} className={styles.container}>
      <AppTitle titleType="primary" level={5}>
        <AppHighlighter
          searchWords={[props.textQuery]}
          textToHighlight={noteResponse?.title || ""}
        />
      </AppTitle>
      <div className={styles.fields}>
        {props.item.fields.map((field, index) => {
          return (
            <SearchCardField type="note" textQuery={props.textQuery} field={field} key={index} />
          );
        })}
      </div>
    </div>
  );
};
